export default {
  'STATUSTEMPLATE' (state) {
    return state.statusTemplate
  },
  'STATUSTEMPLATES' (state) {
    return state.statusTemplates
  }
}
